import FormGroupRenderer, {
  ILabelColumnSize,
} from '@app/components/FormGroupRenderer'
import { SiteSuggestionStatus } from '@app/models/enums'
import { ISiteSuggestion } from '@app/models/SiteSuggestion'
import { bindFunctions } from '@app/utils/class'
import {
  formatCurrency,
  formatDate,
  formatPhoneNumber,
} from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Button, Card, CardBody, CardHeader } from 'reactstrap'

import { actionCreators, ISiteListState } from '../modules/siteList'
import './SiteList.scss'

interface IComponentRouteProps {
  slug: string
}

type IComponentProps = ISiteListState &
  typeof actionCreators &
  RouteComponentProps<IComponentRouteProps>

class SuggestionsList extends React.PureComponent<IComponentProps> {
  public labelColSizes: ILabelColumnSize
  public secondColumnSizes: ILabelColumnSize

  public constructor(props: any) {
    super(props)

    bindFunctions(this)

    this.props.loadSuggestions()

    this.labelColSizes = {
      md: 5,
      xl: 4,
    }

    this.secondColumnSizes = {
      md: 8,
      xl: 7,
    }
  }

  public render() {
    const suggestions = this.props.suggestions.toArray().map((item, index) => {
      return (
        <Card className='mt-2' key={`suggestion-${index}`}>
          <CardHeader>
            <div className='d-flex flex-row justify-content-between'>
              <span>
                <strong>{this._renderSingleLineAddress(item)}</strong>
              </span>
              {this._renderStatus(item)}
            </div>
          </CardHeader>
          <CardBody>
            {this._renderContent(item)}
            {this._renderFiles(item)}
          </CardBody>
        </Card>
      )
    })

    return <div className='mt-4'>{suggestions}</div>
  }

  private _renderContent(item: ISiteSuggestion) {
    return (
      <div className='d-flex flex-column'>
        <div className='d-flex flex-row flex-wrap justify-content-between mt-2'>
          <div className='d-flex flex-column flex-grow-1'>
            <FormGroupRenderer
              style={{ marginBottom: 0 }}
              labelColSizes={this.labelColSizes}
              labelText='Contact Name'
            >
              {item.contactName}
            </FormGroupRenderer>

            <FormGroupRenderer
              style={{ marginBottom: 0 }}
              labelColSizes={this.labelColSizes}
              labelText='Contact Company'
            >
              {item.contactCompany}
            </FormGroupRenderer>

            <FormGroupRenderer
              style={{ marginBottom: 0 }}
              labelColSizes={this.labelColSizes}
              labelText='Phone Number'
            >
              {formatPhoneNumber(item.contactPhone)}
            </FormGroupRenderer>

            <FormGroupRenderer
              style={{ marginBottom: 0 }}
              labelColSizes={this.labelColSizes}
              labelText='Email Address'
            >
              <a href={`mailto:${item.contactEmail}`}>{item.contactEmail}</a>
            </FormGroupRenderer>
          </div>

          <div className='d-flex flex-column flex-grow-1 text-md-right'>
            <FormGroupRenderer
              style={{ marginBottom: 0 }}
              labelColSizes={this.secondColumnSizes}
              labelText='On the market'
            >
              <div>{item.onTheMarket ? 'Yes' : 'No'}</div>
            </FormGroupRenderer>
            <FormGroupRenderer
              style={{ marginBottom: 0 }}
              labelColSizes={this.secondColumnSizes}
              labelText='Market price'
            >
              <div>{formatCurrency(item.marketPrice)}</div>
            </FormGroupRenderer>
            <FormGroupRenderer
              style={{ marginBottom: 0}}
              labelColSizes={this.secondColumnSizes}
              labelText='Date Created'>
                <div>{formatDate(
              item.dateCreated,
              'MM/DD/YYYY',
            )}</div>
            </FormGroupRenderer>
          </div>
        </div>
      </div>
    )
  }

  private _renderFiles(item: ISiteSuggestion) {
    const files = item.files.toArray().map((file) => {
      return (
        <div key={file.id} className='mt-2 d-flex flex-row'>
          <div className='d-flex flex-column'>
            <div>
              <strong>{file.fileName}</strong>
              <Button
                color='link'
                title='Download'
                href={`/api/Files/${file.id}/Download`}
                target='_blank'
              >
                <FontAwesomeIcon icon={['fal', 'download']} fixedWidth />
              </Button>
            </div>
            <div
              className='text-muted'
              style={{ fontSize: '0.875rem' }}
            >{`Uploaded ${formatDate(
              file.dateCreated,
              'MMM DD, YYYY h:mm a',
            )}`}</div>
          </div>
          <div />
        </div>
      )
    })

    return <div>{files}</div>
  }

  private _renderSingleLineAddress(item: ISiteSuggestion) {
    return `${item.siteAddress} ${
      item.siteCity
    }, ${item.siteState.toUpperCase()} ${item.siteZip}`
  }

  private _renderStatus(item: ISiteSuggestion) {
    if (item.status === 'Approved' || item.status === 'Denied') {
      return (
        <div className={`suggestion-status-${item.status.toLowerCase()}`}>
          {item.status === SiteSuggestionStatus.Approved
            ? 'Approved'
            : 'Denied'}
        </div>
      )
    }

    return (
      <div>
        <Button size='sm' outline color='secondary' onClick={() => this.props.approveSuggestion(item.id)}>
          <FontAwesomeIcon icon={['fal', 'thumbs-up']} fixedWidth />
          Approve
        </Button>
        <Button className='ml-2' size='sm' outline color='danger' onClick={() => this.props.denySuggestion(item.id)}>
          <FontAwesomeIcon icon={['fal', 'thumbs-down']} fixedWidth />
          Deny
        </Button>
      </div>
    )
  }
}

export default withRouter(SuggestionsList)
